export const floorSize = 80;
export const cornerYOffset = 0.05;

export const theColor = '#D85BE5';

export const cornerData = [
  { id: 'right', position: [floorSize/4, cornerYOffset, floorSize/4]},
  { id: 'bottom', position: [-floorSize/4, cornerYOffset, floorSize/4]},
  { id: 'left', position: [-floorSize/4, cornerYOffset, -floorSize/4]},
  { id: 'top', position: [floorSize/4, cornerYOffset, -floorSize/4]}
];

export const inMultiplier = 1.5;

/**
 * Truncates a number to a specific number of decimal places
 * @param {number} num - The number to truncate
 * @param {number} decimalPlaces - Number of decimal places to keep
 * @returns {string} - Formatted string with fixed decimal places
 */
export const truncateToDecimal = (num, decimalPlaces) => {
  const factor = Math.pow(10, decimalPlaces);
  const truncatedValue = Math.floor(num * factor) / factor;

  // Force the value to be a string with the desired decimal places
  return truncatedValue.toFixed(decimalPlaces);
};